import { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

let cachedAnimation = null;

const LoadingIndicator = ({ size = 120, className = '' }) => {
  const [animationData, setAnimationData] = useState(cachedAnimation);

  useEffect(() => {
    if (cachedAnimation) return;

    const loadAnimation = async () => {
      try {
        const response = await fetch('/assets/json/loadingcircle.json');
        const animation = await response.json();
        cachedAnimation = animation;
        setAnimationData(animation);
      } catch (error) {
        console.error('Loading animation fetch error:', error);
      }
    };

    loadAnimation();
  }, []);

  if (!animationData) return null;

  return (
    <div className={`loading-indicator ${className}`} style={{ width: size, height: size }}>
      <Lottie animationData={animationData} loop />
    </div>
  );
};

export default LoadingIndicator;
